import { BrightcoveDriver } from '../drivers/brightcove';
import { ConsoleDriver } from '../drivers/console';
import { GoogleDriver } from '../drivers/ga';
import { Driver, DriverConfig } from '../types';

/**
 * mapConfigToDriver
 *
 * Maps the driver config and returns an instance of the correct driver
 *
 * @param config - Config for the driver to be instantiated
 * @returns An instantiated driver
 */
export const mapConfigToDriver = (config: DriverConfig): Driver => {
    switch (config.type) {
        case 'console':
            return ConsoleDriver(config);
        case 'ga':
            return GoogleDriver(config);
        case 'brightcove':
            return BrightcoveDriver(config);
        default:
            throw new RangeError(`Unsupported config type`);
    }
};
